import iziToast from "izitoast"

export const mostrarToastSuccess = (titulo, mensaje) => {
  iziToast.success({
    title: titulo,
    message: mensaje,
    messageSize: '16',
    titleSize: '16',
    position: 'bottomRight',
  })
}

export const mostrarToastError = (titulo, mensaje) => {
  iziToast.error({
    title:titulo,
    message: mensaje,
    messageSize: '16',
    titleSize: '16',
    position: 'bottomRight',
  })
}